/**
 * OVERRIDE Header.jsx
 */

import Header from '../../../../components/Header/Header';

export default Header; 